import styles from "./styles.module.css";

export const Error = () => {
  return (
    <div className={styles.wrapper}>
      Erro ao carregar os dados. <br />☹
    </div>
  );
};
